<template>
  <v-card outlined class="mb-2 hidden-sm-and-down">
    <v-card-text>
      <highcharts
        ref="highcharts"
        v-if="options"
        :options="options"
      ></highcharts>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      required: true
    }
  }
}
</script>
